import type { ReactElement } from 'react';

import {
  Divider,
  Skeleton
} from '@/modules/perseo-billing/ui/react/src/components/beta';

export const SkeletonSummary = (): ReactElement => (
  <div
    className="co-m-1 co-border-1 co-border-[#E6E6E6] co-rounded co-flex co-flex-col co-w-full co-h-auto co-mx-auto co-p-16px"
    data-testid="paris-purchase-summary-skeleton"
  >
    <div className="co-flex co-flex-col co-gap-16px">
      <RectSkeleton className="co-w-1/2 co-h-8" />
      <RectSkeleton className="co-w-full co-h-8" />

      <div className="co-flex co-flex-col co-gap-16px co-px-16px co-py-8px co-bg-pds-neutral-100">
        <div className="co-flex co-gap-16px">
          <RectSkeleton className="co-min-w-[60px] co-max-w-[60px] co-min-h-[45px] co-max-h-[45px] co-border-1 co-border-[#AAAAAA80] co-rounded-4px" />
          <div className="co-flex co-flex-col co-w-full co-gap-2px">
            <RectSkeleton className="co-w-full co-h-4" />
            <RectSkeleton className="co-w-full co-h-4" />
          </div>
        </div>

        <div className="co-flex co-gap-16px">
          <RectSkeleton className="co-min-w-[60px] co-max-w-[60px] co-min-h-[45px] co-max-h-[45px] co-border-1 co-border-[#AAAAAA80] co-rounded-4px" />
          <div className="co-flex co-flex-col co-w-full co-gap-2px">
            <RectSkeleton className="co-w-full co-h-4" />
            <RectSkeleton className="co-w-full co-h-4" />
          </div>
        </div>
      </div>
      <Divider />
      <RectSkeleton className="co-w-full co-h-8" />
      <Divider />
      <RectSkeleton className="co-w-full co-h-8" />
      <RectSkeleton className="co-w-full co-h-8" />
      <Divider />
      <RectSkeleton className="co-w-full co-h-8" />
      <RectSkeleton className="co-w-full co-h-8" />
      <div className="co-flex co-bg-pds-neutral-100 co-w-full co-px-16px co-py-[12px] co-gap-8px co-justify-between">
        <div className="co-flex co-gap-8px">
          <div className="co-min-w-32px co-min-h-32px">
            <Skeleton variant="circular" />
          </div>
          <RectSkeleton className="co-w-176px co-h-8" />
        </div>
        <div className="co-min-w-24px co-min-h-24px co-max-w-24px co-max-h-24px">
          <Skeleton variant="circular" />
        </div>
      </div>
    </div>
  </div>
);

export const SkeletonDelivery = (): ReactElement => (
  <div
    className="co-p-4 co-border-1 co-border-[#E6E6E6] co-rounded"
    data-testid="paris-delivery-types-skeleton"
  >
    <div className="co-flex co-flex-col co-gap-16px">
      <RectSkeleton className="co-w-full co-h-8" />

      <div className="co-flex co-flex-col co-gap-8px co-px-16px co-py-8px co-bg-pds-neutral-100">
        <RectSkeleton className="co-w-full co-h-8" />
        <Divider />
        <RectSkeleton className="co-w-full co-h-8" />
        <RectSkeleton className="co-w-full co-h-8" />
      </div>
    </div>
  </div>
);

const RectSkeleton = ({ className }: Record<string, string>) => (
  <div className={`co-rounded-4px ${className}`}>
    <Skeleton variant="rectangular" />
  </div>
);
